import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const TableSortDirectionArrowDescGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g {...(props.group ?? {})}>
      <path
        d="M8.27279 2.78027C7.98503 2.78027 7.78027 2.97949 7.78027 3.26725V10.5553L7.82454 11.7396L6.16439 9.91894L4.90267 8.67936C4.81966 8.59082 4.68685 8.54655 4.55404 8.54655C4.27734 8.54655 4.07812 8.75683 4.07812 9.02799C4.07812 9.16081 4.12793 9.27702 4.23307 9.38769L7.90202 13.0677C8.00716 13.1784 8.13444 13.2337 8.27279 13.2337C8.41113 13.2337 8.53841 13.1784 8.64355 13.0677L12.318 9.38769C12.4232 9.27702 12.4674 9.16081 12.4674 9.02799C12.4674 8.75683 12.2682 8.54655 11.9915 8.54655C11.8587 8.54655 11.7314 8.59082 11.6429 8.67936L10.3812 9.91894L8.72656 11.734L8.7653 10.5553V3.26725C8.7653 2.97949 8.56055 2.78027 8.27279 2.78027Z"
        fill={fillColor}
      />
    </g>
  );
};

export const TableSortDirectionArrowDescSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      {...(props.svg ?? {})}
    >
      <TableSortDirectionArrowDescGroup {...props} />
    </svg>
  );
};
